import { render } from "./App.vue?vue&type=template&id=724a9874"
const script = {}

import "./App.vue?vue&type=style&index=0&id=724a9874&lang=stylus"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__